import { useL10n } from '@uplift/hooks';
import { useEditableSectionsContext } from '@uplift/ui-v2';
import { useAlert } from 'react-alert';


export const useUpdateSettings = () => {
  const l10n = useL10n();
  const { setEditKey } = useEditableSectionsContext();
  const alert = useAlert();

  const onFormSubmitSuccess = async (message?: string) => {
    alert.success(message ?? l10n.accountSettings.changesUpdatedSuccessfully);
    setEditKey(null);
  };

  const onFormSubmitError = (message?: string) => {
    alert.error(message ?? l10n.accountSettings.changesCouldNotBeSaved);
  };

  return { onFormSubmitSuccess, onFormSubmitError };
};
